import * as React from 'react';
import { cn } from '@/lib/utils';

export interface SegmentedOption<T extends string> {
  value: T;
  label: React.ReactNode;
}

export interface SegmentedControlProps<T extends string> {
  value: T;
  onChange: (value: T) => void;
  options: SegmentedOption<T>[];
  /** Подпись группы для скринридера: «Период». */
  ariaLabel: string;
  className?: string;
}

/**
 * Переключатель-фильтр (role=group + aria-pressed), напр. период «7 дней / 30 дней».
 * Для переключения панелей контента используйте Tabs (role=tablist) — вид тот же.
 */
export function SegmentedControl<T extends string>({ value, onChange, options, ariaLabel, className }: SegmentedControlProps<T>) {
  return (
    <div role="group" aria-label={ariaLabel} className={cn('inline-flex gap-1 rounded-xl bg-muted p-1', className)}>
      {options.map((o) => {
        const active = o.value === value;
        return (
          <button
            key={o.value}
            type="button"
            aria-pressed={active}
            onClick={() => onChange(o.value)}
            className={cn(
              'h-8 whitespace-nowrap rounded-[9px] px-3 text-sm outline-none transition-[background-color,color] focus-visible:ring-2 focus-visible:ring-ring',
              active ? 'bg-surface font-bold text-text shadow-card' : 'font-semibold text-text-2 hover:text-text',
            )}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
